// extracted by mini-css-extract-plugin
export default {"staging_box":"Staging_staging_box__QGy3g"};